import { GROUP_SETTINGS_DATA_REQUEST_ASYNC } from 'containers/GroupSettings/Table/constants'
import { SAVE_DEFAULT_TIMEFRAME_SUCCESS } from 'containers/ResolutionCenter/IncidentsRedesign/actions'

import { SUBMIT_UPSELL_SEEN_INDICATION } from '../AwarenessCenter/constants'
import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from '../PartnerOptions/constants'
import { PARTNER_SETTINGS_UPDATE_ASYNC } from '../Settings/PartnerSettings/constants'

import {
  FETCH_APP_DATA_ASYNC,
  FETCH_APP_NOTIFICATIONS_ASYNC,
  MERGE_AI_CREDITS_NOTIFICATION,
  REFETCH_OWNER_STATUS_ASYNC,
  UPDATE_AI_CREDITS_NOTIFICATION,
} from './constants'

const initialState = {
  isDataLoaded: false,
  data: {
    eula: {
      is_first_login: null,
      update_required: null,
    },
    permissions: {},
    licenses: {},
    ff: {},
    integrations: {},
    tags: [],
    setupStatus: {},
    user: {},
  },
  error: null,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_APP_DATA_ASYNC.SUCCESS: {
      const incoming = action.payload.data || {}
      return {
        ...state,
        error: null,
        isDataLoaded: true,
        data: {
          ...incoming,
          notifications: state.data.notifications ?? incoming.notifications,
        },
      }
    }
    case FETCH_APP_DATA_ASYNC.ERROR:
      return { ...state, error: action.error }
    case FETCH_APP_DATA_ASYNC.CANCEL:
      return { ...state, loader: false }
    case FETCH_APP_NOTIFICATIONS_ASYNC.SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          notifications: action.payload,
        },
      }
    case FETCH_APP_NOTIFICATIONS_ASYNC.ERROR:
    case FETCH_APP_NOTIFICATIONS_ASYNC.CANCEL:
      return state
    case FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS: {
      // data already exist
      if (action.payload.data === null) return state

      let replaced = false
      let companiesData = state.data.partner.companies_data

      companiesData = companiesData.map((e) => {
        if (e.id === action.payload.data.id) {
          replaced = true
          return action.payload.data
        } else return e
      })

      if (!replaced) companiesData.push(action.payload.data)

      return {
        ...state,
        data: {
          ...state.data,
          partner: {
            ...state.data.partner,
            companies_data: companiesData,
          },
        },
      }
    }
    case GROUP_SETTINGS_DATA_REQUEST_ASYNC.SUCCESS: {
      return {
        ...state,
        data: {
          ...state.data,
          partner: { ...state.data.partner, companies_data: [] },
        },
      }
    }
    case PARTNER_SETTINGS_UPDATE_ASYNC.SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          brand: {
            ...state.data.brand,
            default_rc_company: action.payload.default_rc_company,
            default_awareness_company: action.payload.default_awareness_company,
          },
        },
      }
    case REFETCH_OWNER_STATUS_ASYNC.SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          ...action.payload.data,
        },
      }
    case UPDATE_AI_CREDITS_NOTIFICATION:
      return {
        ...state,
        data: {
          ...state.data,
          notifications: state.data.notifications
            ? {
                ...state.data.notifications,
                ai_credits: action.payload,
              }
            : {
                ai_credits: action.payload,
              },
        },
      }
    // Shallow-merge a partial ai_credits update (one discrete socket event updates
    // only its slice — e.g. bell sets {type, reset_date_label}, popup sets
    // {pending_request}). A null payload clears the whole ai_credits notification.
    case MERGE_AI_CREDITS_NOTIFICATION: {
      const prevNotifications = state.data.notifications || {}
      const nextAiCredits =
        action.payload === null
          ? null
          : { ...(prevNotifications.ai_credits || {}), ...action.payload }
      return {
        ...state,
        data: {
          ...state.data,
          notifications: {
            ...prevNotifications,
            ai_credits: nextAiCredits,
          },
        },
      }
    }
    case SUBMIT_UPSELL_SEEN_INDICATION.INITIATE:
      return {
        ...state,
        data: {
          ...state.data,
          disable_premium_popup: true,
        },
      }
    case SAVE_DEFAULT_TIMEFRAME_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          userDefaultIncidentDateFilter: action.payload.userDefaultIncidentDateFilter,
        },
      }
    default:
      return state
  }
}
